<template>
  <text-field-like
    v-bind="$props">
    <hds-id-box :value="value"></hds-id-box>
  </text-field-like>
</template>

<script>
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import HdsIdBox from "@/components/molecules/HdsIdBox.vue";

export default {
  name: "HdsIdField",
  components: {
    HdsIdBox,
    TextFieldLike,
  },
  props: {
    value: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: false
    },
    flat: {
      type: Boolean,
      required: false,
      default: false
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: false
    },
    color: {
      type: String,
      default: 'black'
    },
    dense: {
      type: Boolean,
      default: false
    },
    valueId: {
      type: String
    },
    valueLocalId: {
      type: String
    },
    message: {
      type: String
    },
  },
}
</script>
